import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { RentalListPage } from '@/components/rental-list-page'

export const Route = createFileRoute('/_app/rent/active')({
	component: RentActivePage,
})

function RentActivePage() {
	const { t } = useTranslation()
	return (
		<RentalListPage
			status="ACTIVE"
			withClosingTabs
			emptyTitle={t('rent.active.emptyTitle')}
			emptyDescription={t('rent.active.emptyDescription')}
		/>
	)
}
